// Bileli · modules/spaces/store — reactive UI state for the drain (zustand VANILLA + the Teact adapter;
// the engine mutates these from plain TS, views subscribe via useStoreState).

import type { SpaceDirectoryEntry } from '../model/drain-logic';

import { readDirectory, writeDirectoryEntry } from '../lib/journal';
import { createStore } from '../../../shared/lib/zustandTeact';

export type DrainItemState = 'pending' | 'working' | 'done' | 'failed' | 'orphan';

export interface DrainItem {
  jobId: string;
  title: string;
  state: DrainItemState;
  error?: string;
  /** The created forum's chat id ('-100…' string) — captured at done-time for the «Открыть» button. */
  peerId?: string;
}

export interface DrainState {
  status: 'idle' | 'running';
  items: DrainItem[];
  /** One-line batch outcome («3 создано, 1 ошибка», flood-wait notice, …). */
  note?: string;
}

export const drainStore = createStore<DrainState>(() => ({ status: 'idle', items: [] }));

// The persistent «Созданные пространства» list — seeded from localStorage, updated live as drains ack.
export const directoryStore = createStore<{ spaces: Record<string, SpaceDirectoryEntry> }>(
  () => ({ spaces: readDirectory() }),
);

export function recordSpace(entry: SpaceDirectoryEntry): void {
  writeDirectoryEntry(entry); // localStorage first — the store is just the reactive mirror
  directoryStore.setState((s) => ({ spaces: { ...s.spaces, [entry.cohortId]: entry } }), true);
}

export function resetDrain(items: DrainItem[], note?: string): void {
  drainStore.setState({ status: 'running', items, note }, true);
}

/** Later batches of the same run join the visible list instead of replacing it. */
export function appendDrainItems(items: DrainItem[]): void {
  drainStore.setState((s) => ({ ...s, items: [...s.items, ...items] }));
}

export function patchDrainItem(jobId: string, patch: Partial<DrainItem>): void {
  drainStore.setState((s) => ({
    ...s,
    items: s.items.map((it) => (it.jobId === jobId ? { ...it, ...patch } : it)),
  }), true);
}

export function finishDrain(note: string): void {
  drainStore.setState((s) => ({ ...s, status: 'idle', note }), true);
}
